import {
    createLazyComponent,
    LazyImport,
    LazyModule,
    registerLazyOrchestrator,
} from 'owa-bundling';
import { searchSessionStarted } from 'owa-search-actions';

export { default as getSelectedSuggestion } from './selectors/getSelectedSuggestion';

export const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "FileSearchBox"*/ './lazyIndex')
);

// Register lazy orchestrator
registerLazyOrchestrator(searchSessionStarted, lazyModule, m => m.searchSessionStartedOrchestrator);

// Export lazy component
export let LazyFileSearchBox = createLazyComponent(lazyModule, m => m.FileSearchBox);
export const lazyCreateCloudFileFromFileSuggestion = new LazyImport(
    lazyModule,
    m => m.createCloudFileFromFileSuggestion
);
